// extracted by mini-css-extract-plugin
export default {"title":"title--B6rXL","subTitle":"subTitle--j8LgG","wrapper":"wrapper--Galmt","id":"id--P2qPJ"};